import React from 'react';

const CopySvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.64478 2.45215H16.709V13.355" stroke="white" stroke-opacity="0.6" stroke-width="1.3"/>
    <path d="M13.3555 5.80664H3.29126V15.8708C3.29126 16.3157 3.46798 16.7424 3.78255 17.0569C4.09712 17.3715 4.52376 17.5482 4.96863 17.5482H11.6781C12.123 17.5482 12.5496 17.3715 12.8642 17.0569C13.1787 16.7424 13.3555 16.3157 13.3555 15.8708V5.80664Z" stroke="white" stroke-opacity="0.6" stroke-width="1.3"/>
  </svg>
);

export default CopySvg;